// https://vuex.vuejs.org/en/getters.html

// authorized lets you know if the token is true or not
export default {
  authorized: (state) => !!state.token,
  authstatus: (state) => state.authStatus,
  role: (state) => state.role,
  usermenu: (state) => {
    if (state.usermenu == null) return [];
    return JSON.parse(state.usermenu);
  },
  settings: (state) => {
    if (state.settings == null || state.settings == "undefined") return {};
    return JSON.parse(state.settings);
  },
  user: (state) => {
    if (state.user == null || state.user == "undefined") return { name : null, designation: null };
    return JSON.parse(state.user);
  },
  datetype: (state) => state.datetype,
  inboxcount: (state) => {
    if (state.inboxcount == null) return {};
    return JSON.parse(state.inboxcount);
  },
  company: (state) => {
    if (state.company == null || state.company == "undefined") return {};
    return JSON.parse(state.company);
  },
  applicationtitle: () => "ehajir",
  pagetitle: (state) => state.pagetitle,
  snackbar: (state) => state.snackbar,
  locales: (state) => state.locales,
  dateTypes: (state) => state.dateTypes,
  message: (state) => state.message,
};
